<template>
  <v-card
    v-touch:swipe.left="onSwipeLeft"
    v-touch:swipe.right="onSwipeRight"
    color="#f6f0e1"
    class="notification"
  >
    <v-container fluid>
      <v-layout
        align-space-between
        justify-space-around
        row
        fill-height
      >
        <v-flex
          v-if="notification.icon"
          shrink
        >
          <img :src="notification.icon">
        </v-flex>
        <v-flex>
          <v-layout
            align-space-between
            justify-space-around
            column
            fill-height
          >
            <v-flex shrink>
              <h3>{{ notification.title }}</h3>
            </v-flex>
            <v-flex grow>
              <p>{{ notification.body }}</p>
            </v-flex>
          </v-layout>
          <v-layout
            align-center
            justify-space-between
            row
            class="btn-row"
          >
            <v-flex>
              <v-btn
                round
                color="danger"
                @click="onClearClick"
              >
                <v-icon color="text">
                  mdi-delete
                </v-icon>
              </v-btn>
            </v-flex>
             <v-flex>
              <v-btn
                round
                color="primary"
                @click="onNavClick"
              >
                <v-icon color="text">
                  mdi-information
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: ["notification"],
  methods: {
    onSwipeLeft() {
      this.remove();
    },
    onSwipeRight() {
      this.remove();
    },
    onClearClick() {
      this.remove();
    },
    onNavClick() {
       this.$emit("nav");
    },
    remove() {
      this.$emit("remove");
    }
  }
};
</script>

<style scoped>
.notification {
  margin: 1rem;
  padding: 1rem;
  margin-bottom: 2rem;
}

.notification img {
  max-width: 10vw;
  max-height: 10vh;
}

.btn-row {
  margin-top: -2rem;
}
</style>
